import {v4 as uuidv4} from 'uuid';
function chillHop() {
  return [
    {
      name: 'Pink Matter',
      cover:
        'https://docs.google.com/uc?export=download&id=1biMawbIQzvD3jRQCOC6rctuI9rZagWfl',
      artist: 'Frank Ocean',
      audio:
        'https://docs.google.com/uc?export=download&id=1sVZy8_6kPsUcvOEw9SNSLAZdWD0-siat',
      color: ['#FF7302', '#FFCD9A'],
      id: uuidv4(),
      active: true,
    },
    {
      name: 'Black Sands',
      cover:
        'https://docs.google.com/uc?export=download&id=1xm6U-40cewuaB19po-gIBp0eSpBnII5g',
      artist: 'bonobo',
      audio:
        'https://docs.google.com/uc?export=download&id=1Ey0z1K-XAnLRu149lMjpm_wIzqBgfH-t',
      color: ['#639DAB', '#284530'],
      id: uuidv4(),
      active: false,
    },
    {
      name: 'Hyperballad',
      cover:
        'https://docs.google.com/uc?export=download&id=1NVJNZPN6VNVkuoO0Ro0ZQCkwjrC4KG8x',
      artist: 'Björk',
      audio:
        'https://docs.google.com/uc?export=download&id=14vdYo3kJzuqn5xZ425eZOXtpzBxeJK2X',
      color: ['#284B98', '#BF3A71'],
      id: uuidv4(),
      active: false,
    },
    {
      name: 'Vanessa',
      cover:
        'https://docs.google.com/uc?export=download&id=1UV2__eo6wcZnMYhCuAgi_dtJ1LZsXt0K',
      artist: 'Grimes',
      audio:
        'https://docs.google.com/uc?export=download&id=1FzGFA0dzDlulES-TXnDK4A9eyJQtPgQb',
      color: ['#B34825', '#88B05F'],
      id: uuidv4(),
      active: false,
    },

    {
      name: 'Aruarian Dance',
      cover:
        'https://docs.google.com/uc?export=download&id=1giQkORyUBYuzJKhGZPdLss6HUDDQKdy1',
      artist: 'Nujabes',
      audio:
        'https://docs.google.com/uc?export=download&id=1EmwdeU_XpxSx0h7VqU-ukLdqZbEtUBSA',
      color: ['#0052A6', '#80A3D3'],
      id: uuidv4(),
      active: false,
    },
    {
      name: 'Glowed Up',
      cover:
        'https://docs.google.com/uc?export=download&id=1IDRi6pnTBXekwd8Ox1gKSmUu3CLbxsyo',
      artist: 'KAYTRANADA & Anderson.Paak',
      audio:
        'https://docs.google.com/uc?export=download&id=1pOpL7aj441xl6lVm2ZmbG1Cg1EeXU89s',
      color: ['#693396', '#F92700'],
      id: uuidv4(),
      active: false,
    },
    {
      name: 'Meine',
      cover:
        'https://docs.google.com/uc?export=download&id=1OT-Zzl7mHlj9umDPU8iZ9UIIm0_tZK27',
      artist: 'Daso',
      audio:
        'https://docs.google.com/uc?export=download&id=14hfdreasvkhGs3gpC65jvPbbQZO-TDsB',
      color: ['#22798A', '#E50080'],
      id: uuidv4(),
      active: false,
    },
    {
      name: 'Tyrant',
      cover:
        'https://docs.google.com/uc?export=download&id=1lXpc2q2IEF-sr8jFVrosGSxZeXML9AZm',
      artist: 'Kali Uchis & Jorja Smith',
      audio:
        'https://docs.google.com/uc?export=download&id=1QoaTlpD-EytwfHp2NgQJ1WdTPwvoHBH-',
      color: ['#D8AF2C', '#0C1AD2'],
      id: uuidv4(),
      active: false,
    },
    {
      name: 'Suede',
      cover:
        'https://docs.google.com/uc?export=download&id=1L8nuxwWhQxWdk8mjZY6wKOGCHhrPx_Jh',
      artist: 'Anderson.Paak & Knxwledge',
      audio:
        'https://docs.google.com/uc?export=download&id=1ZzNKe8YlqIayow5Kw5ojfnGKwiSg8Yuu',
      color: ['#88847D', '#040003'],
      id: uuidv4(),
      active: false,
    },
    {
      name: 'See You Again',
      cover:
        'https://docs.google.com/uc?export=download&id=1gy173RKsFZBRixBRcibVCAJAMW8OarRl',
      artist: 'Tyler, the creator',
      audio:
        'https://docs.google.com/uc?export=download&id=1O8KP2VPE8ydU6GJLPFRmrLVJQPHDEeHk',
      color: ['#FEBA2A', '#CF2D19'],
      id: uuidv4(),
      active: false,
    },
    {
      name: 'RUNAWAY',
      cover:
        'https://docs.google.com/uc?export=download&id=1nPPLcPWivFaXx4Mf71R5g4gRhk7im6q2',
      artist: 'Kanye West',
      audio:
        'https://docs.google.com/uc?export=download&id=1gaBAoy3TgGJromkwpGHoOP47ZW2iSkqW',
      color: ['#CE263F', '#468354'],
      id: uuidv4(),
      active: false,
    },
    {
      name: 'Forgive Me',
      cover:
        'https://docs.google.com/uc?export=download&id=1RA64eq5eQutbZwFmkcmJsqu1EbgKOvfP',
      artist: 'Chloe x Halle',
      audio:
        'https://docs.google.com/uc?export=download&id=1bRE3J30V6mBj68bxZ4JbQdT07lGxodSS',
      color: ['#D49663', '#2A1712'],
      id: uuidv4(),
      active: false,
    },
    {
      name: 'Emerald Rush',
      cover:
        'https://docs.google.com/uc?export=download&id=18RtMlx8Nr63n7ysItru2P8JPN_sf7oYp',
      artist: 'Jon Hopkins',
      audio:
        'https://docs.google.com/uc?export=download&id=1vRx_yld-TUjk9dlg1hz3J3eMQaEDWpCS',
      color: ['#3E4879', '#E4B86E'],
      id: uuidv4(),
      active: false,
    },
    {
      name: 'Girl',
      cover:
        'https://docs.google.com/uc?export=download&id=1wf2PBVqjw9i-bqncDiS0mHvPJd2TQjuN',
      artist: 'The Internet',
      audio:
        'https://docs.google.com/uc?export=download&id=1vxiyPvGsRigaNZJE9XHFoFG1Kwmj-Cvm',
      color: ['#383A7C', '#F98424'],
      id: uuidv4(),
      active: false,
    },
    {
      name: 'NAUFRAGE EN ADRIATIQUE',
      cover:
        'https://docs.google.com/uc?export=download&id=1zlb0L7ANuU7dzc0RSJaXEUbRag8fNcne',
      artist: "L'Impératrice",
      audio:
        'https://docs.google.com/uc?export=download&id=1MPNZ7IzELoUEPULyFaLmpVGLkXGiDc6P',
      color: ['#464340', '#2A232A'],
      id: uuidv4(),
      active: false,
    },
  ];
}

export default chillHop;
